const global = window

// Remplissage automatique
inputs.behavior.request = function (data, name, niceName, type, input, parent, inputWindow) {
    const apiForm = input.closest('[data-api]')
    const apiFormData = apiForm.data('data')

    if (data.request) {
        input.click(function(event) {
            if (!input.data('hold') && apiForm) {
                const url = apiForm.data('api');
                if (!url) {
                    console.error('No API URL provided')
                    return false
                }
                callAPI((data.request.method) ? data.request.method : 'PUT', url, data.request.data, function () {
                    if (event.type === 'click') {
                        if (parent && parent.closeWindow) parent.closeWindow();
                        if (data.request.method == 'DELETE') {
                            apiForm.remove();
                        }
                        else if (apiFormData && apiFormData.ajax) {
                            apiFormData.reload();
                        }
                    }
                });
            }
        })
    }
    return data
}
